import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class depotsMultiSelectListCtrl implements IController {
  selectedIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isPickupEnabled: boolean;
  isDropoffEnabled: boolean;
  noPickUp: boolean;
  noDropOff: boolean;
  onChangeFilterNoPickUp: Function;
  onChangeFilterNoDropOff: Function;
  onChange: Function;

  public excludedMap: Object;
  private depotsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $depots, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {

    this.depotsRef = this.$depots();
    this.loadLimit = 20;

    this.depotsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.depotsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  onToggle(depotId, isSelected) {
    this.onChange({
      depotIds: isSelected ? _.concat(this.selectedIds || [], [depotId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== depotId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({depotIds: []});
    } else {
      this.onChange({depotIds: this.infiniteScroll?.getItems()?.map((depot) => depot.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(depot => depot.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.depotsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.depots')
  .component('depotsMultiSelectList', {
    bindings: {
      selectedIds: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isPickupEnabled: '<?',
      isDropoffEnabled: '<?',
      noPickUp: '<?',
      noDropOff: '<?',
      onChange: '&',
      onChangeFilterNoPickUp: '&',
      onChangeFilterNoDropOff: '&'
    },
    template: require('./depots-multi-select-list.html').default,
    controller: depotsMultiSelectListCtrl
  });
